import { render } from "./home-page.vue?vue&type=template&id=204e980c&scoped=true"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"

import "./home-page.vue?vue&type=style&index=0&id=204e980c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204e980c"]])

export default __exports__